import DatetimePicker from "vuetify-datetime-picker";
import store from "@/store";
import uk from 'vuetify/es5/locale/uk'
import en from 'vuetify/es5/locale/en'
import Vuetify from "vuetify/lib";
import { facilityLanguageIsoToShortLocale } from "@/utils/localization";
import Vue from "vue";
import { defaultFacilityValues } from "@/consts/defaultFacilityValues";

Vue.use(Vuetify);
Vue.use(DatetimePicker);

const facilityLanguageIso = store?.state?.facilityModule?.selectedFacility?.languageIso || defaultFacilityValues.shortLocale
const locale = facilityLanguageIsoToShortLocale(facilityLanguageIso)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#3f51b5",
        secondary: "#7575a3",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  },
  lang: {
    locales: {
      uk, 
      en
    },
    current: locale
  },
});


export default vuetify